import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const CONSENT_VERSION = 1;

interface ConsentStore {
  version: number;
  analytics: boolean | null;
  marketing: boolean | null;
  decidedAt: string | null;
  acceptAll: () => void;
  rejectAll: () => void;
  reset: () => void;
}

const UNDECIDED = {
  version: CONSENT_VERSION,
  analytics: null,
  marketing: null,
  decidedAt: null,
} as const;

const decide = (value: boolean) => ({
  version: CONSENT_VERSION,
  analytics: value,
  marketing: value,
  decidedAt: new Date().toISOString(),
});

export const useConsentStore = create<ConsentStore>()(
  persist(
    (set) => ({
      ...UNDECIDED,
      acceptAll: () => set(decide(true)),
      rejectAll: () => set(decide(false)),
      reset: () => set({ ...UNDECIDED }),
    }),
    {
      name: 'babychic-consent',
      version: CONSENT_VERSION,
      partialize: (s) => ({
        version: s.version,
        analytics: s.analytics,
        marketing: s.marketing,
        decidedAt: s.decidedAt,
      }),
      migrate: () => ({ ...UNDECIDED }),
    }
  )
);
